import { Component, AfterViewInit, inject } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { Offer } from '../../models/offer';
import { OfferActionConfigService } from '../../services/offer-action-config/offer-action-config.service';

@Component({
    selector: 'lib-offer-card-list',
    templateUrl: './offer-card-list.component.html',
    styleUrls: ['./offer-card-list.component.css'],
    standalone: false
})
export class OfferCardListComponent extends ListItemRendererComponent<Offer> implements AfterViewInit {
  /*
    VERY MUCH WIP!! THIS HAS BEEN COPIED FROM THE BC IMPLEMENTATION AND THE FIELDS HAVE BEEN CHANGED TO GME FIELDS
    BUT NO MORE ADJUSTMENTS HAVE BEEN MADE YET.
   */
  protected configService = inject(OfferActionConfigService);

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }
}
